import React, { useEffect, useState, useContext } from "react";
import classNames from "classnames";

// Components
import Paragraph from "../../../../Atoms/Paragraph";
import { TrackingContext } from "../../../../Utils/TrackingWrapper";
import MobileSubNavigation from "./Components/MobileSubNavigation";

// Stylesheets
import styles from "./style.module.scss";

//Constants
import {
  SUB_NAVIGATION_ITEMS,
  SUB_NAVIGATION_UTILITY_NAV,
  SUB_NAVIGATION_SOCIAL,
} from "./Constants/index";
import { HashLink } from "react-router-hash-link";

export const MobileNavigation = ({ navState }) => {
  const [activeSubNavigation, setActiveSubNavigation] = useState("");
  const {
    trackingActions: { trackNavigation },
  } = useContext(TrackingContext);

  useEffect(() => {
    if (navState) {
      setActiveSubNavigation("adults");
    }
  }, [navState]);

  const handleClick = (handle) => {
    if (handle === activeSubNavigation) {
      setActiveSubNavigation("");
    } else {
      setActiveSubNavigation(handle);
    }
  };

  const onClickLink = (linkText) => {
    trackNavigation({
      clickURL: document.location.pathname,
      clickText: linkText,
      location: "main nav",
    });
  };

  return (
    <nav className={styles.mobileNavigation}>
      <div className={styles.mobileNavigation_container}>
        <ul
          className={classNames(
            styles.mobileNavigation_items,
            styles.listReset
          )}
        >
          {SUB_NAVIGATION_ITEMS.map((item, index) => (
            <li key={index}>
              <button
                className={classNames(
                  styles.mobileNavigation_item,
                  activeSubNavigation === item.handle
                    ? styles.mobileNavigation_itemActive
                    : "",
                  styles.buttonReset
                )}
                onClick={() => handleClick(item.handle)}
                type="button"
              >
                <div className={styles.mobileNavigation_menuItem}>
                  <Paragraph className="body_primary">{item.title}</Paragraph>
                </div>
              </button>

              <div
                className={classNames(
                  styles.mobileNavigation_mobileSubNavigation,
                  activeSubNavigation === item.handle && index !== 0
                    ? styles.mobileNavigation_mobileSubNavigationActive
                    : "",
                  activeSubNavigation === item.handle && index === 0
                    ? styles.mobileNavigation_mobileSubNavigationAdultsActive
                    : ""
                )}
              >
                <MobileSubNavigation menu={item.menu}></MobileSubNavigation>
              </div>
            </li>
          ))}
        </ul>
        <ul
          className={classNames(
            styles.listReset,
            styles.mobileNavigation_utilityNavigation
          )}
        >
          {SUB_NAVIGATION_UTILITY_NAV.map((item, index) => (
            <li key={index}>
              <HashLink
                className={classNames(
                  styles.linkReset,
                  styles.mobileNavigation_menuItem
                )}
                smooth
                to={item.url}
                onClick={() => {
                  onClickLink(item.title);
                }}
              >
                <Paragraph
                  className={classNames(
                    styles.mobileNavigation_utilityNavigationParagraph,
                    "body_primary"
                  )}
                >
                  {item.title}
                </Paragraph>
              </HashLink>
            </li>
          ))}
        </ul>
        <ul
          className={classNames(
            styles.listReset,
            styles.mobileNavigation_socialNavigation
          )}
        >
          {SUB_NAVIGATION_SOCIAL.map((item, index) => (
            <li key={index}>
              <a
                className={classNames(
                  styles.linkReset,
                  styles.mobileNavigation_socialIcon
                )}
                href={item.url}
              >
                {item.icon}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default MobileNavigation;
